import { render } from "./InstallSteps.vue?vue&type=template&id=6529ef7a&scoped=true"
import script from "./InstallSteps.vue?vue&type=script&lang=js"
export * from "./InstallSteps.vue?vue&type=script&lang=js"

import "./InstallSteps.vue?vue&type=style&index=0&id=6529ef7a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6529ef7a"]])

export default __exports__